import script from "./WidgetModule.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetModule.vue?vue&type=script&setup=true&lang=js"

import "./WidgetModule.vue?vue&type=style&index=0&id=c9c4a710&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9c4a710"]])

export default __exports__